<template>
    <div v-if="is_not_correct_user||is_correct_user">

        <div class="con"
             v-if="is_not_correct_user">
            <h3>未批改<span>{{is_not_correct_user.length}}</span>人</h3>
            <div class="uncorrect correctbox">
                <span v-for="(item,index) in is_not_correct_user"
                      :key="index">{{item}}</span>
            </div>
        </div>
        <div class="con"
             v-if="is_correct_user.length">
            <h3>已批改<span>{{is_correct_user.length}}</span>人</h3>
            <div class="corrected correctbox">
                <table>
                    <tbody>
                        <tr>
                            <th>姓名</th>
                            <th>成绩</th>
                            <th>提交时间</th>
                        </tr>
                        <tr v-for="(item,index) in is_correct_user"
                            :key="index"
                            @click="toDetail(item)">
                            <td>{{item.username}}</td>
                            <td>{{item.score}}分</td>
                            <td class="c-999">{{item.test_date}} <i class="icon_arrow_right"></i></td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</template>
<script>
import * as echarts from 'echarts';
export default {
    props: ['is_correct_user', 'is_not_correct_user', 'score_group', 'message_id', 'unitId', 'unit_score_rate'],
    data () {
        return {
            inApp: localStorage.getItem("search") && Number(JSON.parse(localStorage.getItem("search")).platform),
            array: [],
            sid: this.$route.query.sid,
            cid: this.$route.query.taskId
        }
    },
    created () {

    },
    mounted () {
        setTimeout(() => {

            MathJax.Hub.Typeset(document.body)
        }, 500)
    },
    watch: {
        unitId () {
            //console.log(this.unitId)
            setTimeout(() => {

                MathJax.Hub.Typeset(document.body)
            }, 500)
        }
    },
    computed: {

    },
    methods: {
        setIndex (score) {
            let num = score == 0 ? 0 : parseInt(score / 20);
            if (score == 100) {
                num = 4;
            }
            return num;
        },

        toDetail (stu) {
            localStorage.setItem('teaTaskUnitData', JSON.stringify(this.array))
            let qz_text = this.$route.query.testType == "qz" ? "&is_qz=1" : '';
            this.$router.push(`/personaLearning/stuDetail?sid=${this.sid}&cid=${this.cid}&userId=${stu.user_id}&name=${stu.username}&score=${stu.score}${qz_text}`);
        },
        picView (index) {
            this.$router.push('/chinese/inspect/mytask/' + this.message_id + '/' + index.user_id + '/' + index.real_name + '?score=' + index.score)
        },
    },

}
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
.box {
    width: 600px / $ppr;
    margin: 25px / $ppr auto 30px / $ppr;
    background: #fff;
    padding: 30px / $ppr 30px / $ppr 46px / $ppr;
    border-radius: 16px / $ppr;
    h3 {
        font-size: 30px / $ppr;
        margin-bottom: 24px / $ppr;
        line-height: 56px / $ppr;
        position: relative;
        padding-left: 48px / $ppr;
        font-weight: bold;
        i {
            position: absolute;
            left: 0;
            top: 50%;
            margin-top: -17px / $ppr;
            display: block;
            width: 32px / $ppr;
            height: 32px / $ppr;
            background: url("../img/icon04.png") 0 0 no-repeat;
            background-size: 100% 100%;
        }
    }
}
.con {
    width: 660px / $ppr;
    margin: 0 auto;
    h3 {
        color: #3c7cfb;
        font-size: 24px / $ppr;
        line-height: 74px / $ppr;
        height: 74px / $ppr;
        font-weight: bold;
        span {
            font-size: 28px / $ppr;
        }
    }
    .correctbox {
        width: 600px / $ppr;
        padding: 24px / $ppr 30px / $ppr;
        margin: 0 auto 35px / $ppr;
        border-radius: 16px / $ppr;
        background: #fff;
    }
    .uncorrect {
        span {
            width: 25%;
            display: inline-block;
            text-align: center;
            line-height: 80px / $ppr;
            height: 80px / $ppr;
            overflow: hidden;
        }
    }
    .corrected {
        width: 100%;
        padding: 0;
        table {
            text-align: center;
            width: 100%;
            th {
                font-weight: bold;
            }
            th,
            td {
                width: 33.33333%;
                text-align: center;
                padding-top: 30px / $ppr;
                padding-bottom: 30px / $ppr;
            }
            tr {
                &:nth-child(2n) {
                    background: #fafafa;
                }
            }
        }
        .icon_arrow_right {
            display: inline-block;
            width: 12px / $ppr;
            height: 22px / $ppr;
            background: url(../img/icon_arrow_right.png) no-repeat center;
            background-size: cover;
            margin-left: 10px / $ppr;
        }
    }
}
.c-999 {
    color: #999;
}
</style>
